/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import Tooltip from '../../components/tooltip/Tooltip';
import {StarsFillIcon} from '../../icons/StarsFillIcon';
import {SystemLocationIcon} from '../../icons/SystemLocationIcon';
import {dlsAlt, dlsColor, dlsLayout} from '../../theme/theme';
import SearchPlaceItemLabel from './SearchPlaceItemLabel';
import {PlaceItemProps} from './SearchView';

// defines the styles for this component ...
const useStyles = makeStyles(theme => ({
  searchItem : {
    display    : 'flex',
    alignItems : 'center',
    minHeight  : '48px',
    cursor     : 'default',
    maxWidth   : 285,
    '&:hover'  : {
      backgroundColor : dlsAlt('colors', 'paleBlue2')
    }
  },
  searchItemElement : {
    display      : 'flex',
    paddingLeft  : dlsLayout('margins') / 2,
    paddingRight : dlsLayout('margins') / 3,
    maxWidth     : 200
  }
}));

export const SearchPlaceItem = ({
  result,
  onDeleteItem,
  onClick,
  placeSearchText,
  isSavedPlace
}: PlaceItemProps) => {
  const classes = useStyles();

  return (
    <div key={result.magicKey} onClick={onClick} className={classes.searchItem}>
      <div className={classes.searchItemElement}
        onClick={function(event) {
          event.stopPropagation();
        }}>
        {isSavedPlace && (
          <Tooltip title={`${translate('maps:searchMap.removeFromSaved')}`} arrow>
            <div onClick={function() {
              onDeleteItem(result);
            }}>
              <StarsFillIcon />
            </div>
          </Tooltip>
        )}
        {!isSavedPlace && <SystemLocationIcon />}
      </div>
      <div className={classes.searchItemElement} style={{width: '100%'}}>
        <SearchPlaceItemLabel item={result} searchTerm={placeSearchText} isSaved={isSavedPlace} />
      </div>
    </div>
  );
};
export default SearchPlaceItem;
